<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="24">
        <navigator-online @change="onChange" />
      </flex-col>
    </flex>
    <notification :item="notification" />
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageNavigatorOnline',
  mixins: [
    methods
  ],
  data () {
    return {
      notification: {}
    }
  },
  methods: {
    onChange ($event) {
      const lang = this.$lang
      const online = $event.online
      this.log('online', 'navigator-online', $event)
      this.notification = {
        visible: true,
        persistent: false,
        autoClose: 10000,
        icon: 'wifi',
        type: online ? 'success' : 'error',
        title: lang.internetConnection,
        text: lang.internetConnectionText(online)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/content/navigator-online.vue